import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, MenuItem, IconButton, ListItemIcon, Avatar } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SettingsIcon from '@mui/icons-material/Settings';
import customConfig from '../../config';
import { connect } from 'react-redux';

const UserProfileMenu = ({ logout, username, canOpenProfileMenu = true, onMenuOpen, onMenuClose, themeClass = 'dark-blue-theme lime-theme-secondary', primaryColor = '#0f3460' }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  
  const initials = username
    ? username
        .split(/[.\s]/)
        .map((word) => word[0])
        .join('')
        .toUpperCase()
        .substring(0, 2)
    : 'U';

  useEffect(() => {
    if (!canOpenProfileMenu) {
      setAnchorEl(null);
      if (onMenuClose) onMenuClose();
    }
  }, [canOpenProfileMenu, onMenuClose]);

  const handleMenuClose = () => {
    setAnchorEl(null);
    if (onMenuClose) onMenuClose();
  };
const navigate = useNavigate();

  const handleSupport = () => {
    handleMenuClose();
    window.open(customConfig.supportURL, '_blank', 'noopener, noreferrer');
  };

  const handleSettings = () => {
    handleMenuClose();
    navigate('/Settings');
  };

  const handleLogout = () => {
    handleMenuClose();
    logout();
  };

  return (
    <div className='profile-icon'>
      <IconButton
        onClick={handleSettings}
        sx={{ backgroundColor: 'transparent' }}
        aria-controls={Boolean(anchorEl) ? 'profile-menu' : undefined}
        aria-haspopup="true"
      >
        <Avatar
          sx={{
            backgroundColor: '#ffffff',
            color: primaryColor,
            fontWeight: 'bold',
            fontSize: '16px',
            width: '40px',
            height: '40px',
          }}
        >
          <span style={{ color: primaryColor, fontWeight: 'bold', fontSize: '14px' }}>{initials}</span>
        </Avatar>
      </IconButton>

      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        disableScrollLock={true}
        PaperProps={{
          style: {
            marginBottom: 8,
            width: 200,
            maxHeight: 'none',
            overflow: 'visible',
            position: 'absolute',
            zIndex: 10000,
          },
        }}
        MenuListProps={{
          style: {
            padding: '8px 0',
          },
        }}
      >
        <MenuItem onClick={handleSupport}>
          <ListItemIcon>
            <HelpIcon fontSize="small" />
          </ListItemIcon>
          Support
        </MenuItem>
        <Link to="/Settings" style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleMenuClose}>
          <MenuItem>
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            Settings
          </MenuItem>
        </Link>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
          <ExitToAppIcon fontSize="small" />
        </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
};

const mapStateToProps = (state) => ({
  username: state.auth.username,
});

export default connect(mapStateToProps,null)(UserProfileMenu);